/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {PonticDO | null}
 */

export const getPonticDOFromFilePath = async (filePath, fileUrl) => {
  const regex =
    /.*_STAGE_(\d+).*__(LOWER|UPPER)__PONTIC_(\d+).(?!raw$)([^\s.]+)$/i;
  const match = filePath.match(regex);
  if (match) {
    const stageNumber = parseInt(match[1], 10);
    const toothGumType = match[2];
    const ponticNum = parseInt(match[3], 10);
    const fileType = match[4];

    return {
      stageNumber,
      toothGumType,
      ponticNum,
      fileUrl,
      fileType,
      filePath,
    };
  }
  return null;
};
